var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.1808 0 0 7.1808 0 16C0 24.8192 7.1808 32 16 32C24.8192 32 32 24.8256 32 16C32 7.1744 24.8256 0 16 0ZM20.4352 9.4912C20.4352 9.6256 20.3264 9.7344 20.192 9.7344H18.2656C17.792 9.7344 17.408 10.1184 17.408 10.592V12.608H20.1472C20.1536 12.608 20.16 12.608 20.1664 12.608C20.3008 12.6208 20.3968 12.736 20.384 12.8704L20.1408 15.712C20.128 15.84 20.0256 15.936 19.8976 15.936H17.4016V25.3632C17.4016 25.4976 17.2928 25.6064 17.1584 25.6064H13.7152C13.5808 25.6064 13.472 25.4976 13.472 25.3632V16.0768V15.9232H11.7504C11.616 15.9232 11.5072 15.8144 11.5072 15.68V12.8384C11.5072 12.704 11.616 12.5952 11.7504 12.5952H13.472V9.856C13.472 7.9488 15.0208 6.4 16.928 6.4H20.1792C20.3136 6.4 20.4224 6.5088 20.4224 6.6432V9.4912H20.4352Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.fe47661ce578039028ffe0b6878d1753.svg";
export { ForwardRef as ReactComponent };